export default __webpack_public_path__ + "static/media/NextJS-Logo.7ab4af8b.svg";